import { TeamParticipantUserResource } from 'dy-frontend-http-repository/lib/modules/Team/resources';
import { ImageHashPreviewSize } from 'dy-frontend-shared/lib/data/valueObjects/ImageHashPreview/enums';
import React from 'react';

import { Colors } from '@blueprintjs/core';
import Avatar from '@components/Avatar';
import Flex from '@components/Flex';
import RouterLink from '@components/RouterLink';
import { Endpoints, imageHashPreview } from '@data/consts';

import { getMemberRoleLabel } from '../../utils/teamHealth';

export interface MemberIdentityProps {
    user: TeamParticipantUserResource;
}

// Avatar and name, linking to the member's existing details/tasks page
const MemberIdentity: React.FC<MemberIdentityProps> = ({ user }) => {
    const fullName = `${user.first_name} ${user.last_name}`;

    return (
        <Flex align="center">
            <Avatar
                width="32px"
                height="32px"
                className="mr-1"
                alt={fullName}
                src={user.image_hash ? imageHashPreview.userImage(user.image_hash, ImageHashPreviewSize.SM) : undefined}
            />
            <RouterLink color={Colors.WHITE} to={Endpoints.CORE_USER_TASKS.replace(':coreUserId', user.id)}>
                {fullName}
            </RouterLink>
        </Flex>
    );
};

// The same label the Role filter matches on
export const getMemberRole = (user: TeamParticipantUserResource) => getMemberRoleLabel(user.company_position);

export default MemberIdentity;
